import { ForwardedRef, forwardRef, ReactNode } from 'react'

import { TextField } from 'ui-components-web'
import { Merge } from '@ui-components-3/ui/lib/types'
import { TextFieldProps } from '@material-ui/core'

type FormTextareaProps = Merge<
  TextFieldProps,
  {
    label: ReactNode
  }
>

const FormTextarea = forwardRef<ForwardedRef<HTMLTextAreaElement>, FormTextareaProps>(
  ({ inputProps, ...props }, ref) => {
    return (
      <TextField
        {...props}
        inputProps={{ spellCheck: true, ...inputProps }}
        variant="outlined"
        inputRef={ref}
        fullWidth
        multiline
      />
    )
  },
)
FormTextarea.displayName = 'FormTextarea'

export default FormTextarea
